import { SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST, WEEKDAYS_SHORT } from "../../util/constants";
import { ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT } from "./scheduleConstants";
import { TODAY } from "../../util/dateHelper";
import { getIsoDateFormat } from "../dateTimeFormatter";

export const getTodayIsoFormat = (station) => {
  return getIsoDateFormat(TODAY(station));
};

export const getCurrentMonth = (station) => {
  const currentMonthIdx = TODAY(station).month - 1;
  return SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST[currentMonthIdx];
};

export const getSelectableMonthsList = (selectedYear, station) => {
  const currentYear = TODAY(station).year;
  let currentMonthIdx = TODAY(station).month - 1;
  // For current year
  if (selectedYear === currentYear.toString()) {
    // This check prevents an array out of index if currentMonth is not part of the SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST
    if (currentMonthIdx < ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT)
      currentMonthIdx = ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT;
    return SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.slice(currentMonthIdx - ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT);
  } // For previous year
  else if (selectedYear === (currentYear - 1).toString()) {
    if (currentMonthIdx === 0) {
      // January
      return SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.slice(SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.length - 2);
    } else return SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.slice(SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.length - 1); // February
  } // For next year
  else return SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST;
};

export const getCurrentYear = (station) => {
  return TODAY(station).year.toString();
};

export const getSelectableYearsList = (station) => {
  const currentYear = TODAY(station).year;
  const previousYear = (currentYear - 1).toString();
  const nextYear = (currentYear + 1).toString();
  const currentYearStr = currentYear.toString();

  if (TODAY(station).month <= ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT) {
    // If current month is less than or equal to ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT, then we can see the previous year
    return [previousYear, currentYearStr, nextYear];
  } else {
    return [currentYearStr, nextYear];
  }
};

export const convertMonthLongToNumber = (month) => {
  const number = SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.indexOf(month) + 1;
  return number < 10 ? `0${number}` : number.toString();
};

export const getExcludedAssignmentDays = (startDate, endDate) => {
  let excludedAssignmentDays = [];
  const startDateIdx = getDayOfWeekIndex(startDate);
  const endDateIdx = getDayOfWeekIndex(endDate);
  if (startDateIdx === endDateIdx) {
    excludedAssignmentDays = WEEKDAYS_SHORT.filter((day) => day !== getDayOfWeek(startDate));
  } else if (startDateIdx < endDateIdx) {
    const beginningOfWeek = WEEKDAYS_SHORT.slice(0, startDateIdx);
    const endOfWeek = WEEKDAYS_SHORT.slice(endDateIdx + 1);
    excludedAssignmentDays = beginningOfWeek.concat(endOfWeek);
  } else {
    excludedAssignmentDays = WEEKDAYS_SHORT.slice(endDateIdx + 1, startDateIdx);
  }
  return excludedAssignmentDays;
};

const getDayOfWeekIndex = (date) => {
  return WEEKDAYS_SHORT.indexOf(getDayOfWeek(date));
};

const getDayOfWeek = (date) => {
  return date?.weekdayShort?.toUpperCase();
};

export const buildEmployeeDataFromBidRedirect = (bidData, employeeBidData) => {
  const employeeData = {
    eid: employeeBidData.eid,
    firstName: employeeBidData.firstName,
    lastName: employeeBidData.lastName,
    homeStation: bidData.station,
    workgroup: bidData.workgroup,
    ftpt: employeeBidData.ftpt,
  };
  return employeeData;
};
